const resourcesConfig = {
  rewardsGreetingText: 'Loading exciting {br} rewards for you',
  home: 'Home',
  rewardClub: 'Reward Club',
  getGuestMobileNumber: `To Join our Rewards club, {br} Please provide your {br} Mobile number`,
  enterNumberToLogin: 'Please enter your Mobile number',
  logInToYourAccount: 'Log in to your account',
  rewardCondition: 'I agree to receive information, deals and offers from {outletName}',
  verifyMobileNumber: 'Verify Mobile number',
  enterOtpSentOn: 'Enter OTP sent on {phoneNumber}',
  verifyAndLogIn: 'Verify & Log in',
  invalidPhoneNumberMessage: 'Please enter a valid mobile no.',
  tncError: 'Please agree to Terms & Conditions to proceed.',
  emptyOtpMessage: 'Please enter otp',
  guestProfile: 'Guest Profile',
  provideDetails: 'Please provide your details',
  provideMissingDetails: 'Please provide these details to proceed',
  provideDetailsForNewUser: 'To Join our Rewards club,{br}Please provide  following details',
  notProvided: 'Not Provided',
  nameFieldLabel: 'Name',
  phoneNumberLabel: 'OTP will be sent for verification',
  emailFieldLabel: 'Email id',
  birthDateFieldLabel: 'Date of birth',
  anniversaryDateFieldLabel: 'Marriage Anniversary',
  birthdayReward:
    'Your birthday is special for us too. {br} Get an exciting reward for your birthday month',
  anniversaryReward:
    'Elevate your anniversary celebration with us! {br} Enjoy a special reward to make your marriage anniversary unforgettable',
  birthDayAndAnniversaryReward:
    'Your special days are special for us too. {br} Get a special reward for your Birthday & Anniversary',
  hello: 'Hello',
  favouriteLocation: 'Please tell us your Favourite Location',
  selectOutlet: 'Please select the outlet(s) where you visit more often',
  invalidNameMessage: 'Please enter a valid name',
  invalidEmailMessage: 'Please enter a valid email',
  invalidDate: 'Please enter a valid date',
  invalidDateOfBirthMessage: 'Please enter a valid date',
  invalidDateOfAnniversaryMessage: 'Please enter a valid date',
  perferredOutletError: 'Please select your favourite outlet.',
  emptyOutletList: 'No Outlet Found!',
  getStartedCTAText: 'GET STARTED',
  proceedCTAText: 'PROCEED',
  joinRewardClubCTAText: 'JOIN REWARDS CLUb',
  loginCTAText: 'LOGIN',
  doneCTAText: 'DONE',
  guestUserNameText: 'Guest User',
  continueAsGuestText: 'Continue as Guest',
  saveCTAText: 'SAVE',
  updateCTAText: 'UPDATE',
  resendOtp: 'Resend OTP',
  locations: 'Locations',
  locationDetail: 'Location Detail',
  getDirection: 'GET DIRECTION',
  call: 'CALL',
  today: 'Today',
  closed: 'Closed',
  errorInfo: {
    OTP_INVALID: {
      title: 'OTP not verified',
      message: 'It seems like you’ve entered a wrong otp.',
    },
  },
  rewardsClubText: 'Rewards Club',
  rewardProgramDescription:
    'A rewards club that is all about you. Some pep talk about the rewards program that goes into multiple lines covering about 50 words.',
  getAppRewardsClubDescriptionText1: 'Earn points for every rupee spent',
  getAppRewardsClubDescriptionText2: 'Redeem points for exciting rewards',
  getAppDownloadRewardsClubAppText: 'Download app to join Rewards Club',
  getAppRewardClubBenefits: 'Benefits of Rewards Club',
  getAppRewardClubOtherBenefits: 'Other Benefits',
  rewardsText: 'Rewards',
  couponsText: 'Old Coupons',
  rewardsDetailsText: 'Reward Details',
  name: 'Name',
  emailId: 'Email id',
  mobileNo: 'Mobile no.',
  dob: 'Date of Birth',
  dateOfBirthAddedToast: 'Date of Birth Added!',
  dateOfAnniversaryAddedToast: 'Anniversary Added!',
  favouriteLocationText: 'Favourite Locations',
  notification: 'Notifications',
  appNotification: 'App notification',
  sms: 'SMS',
  whatsapp: 'Whatsapp',
  email: 'Email',
  rewardPointHistory: 'Reward Points History',
  history: 'History',
  rewardProgram: 'Rewards Program',
  settings: 'Settings',
  profile: 'Profile',
  shareThisApp: 'Share this app',
  followUsOn: 'FOLLOW US ON',
  logOut: 'LOG OUT',
  login: 'Log in',
  logoutText: 'Logout',
  confirmLogoutMessage: 'Are you sure you want to logout?',
  deleteAccount: 'DELETE ACCOUNT',
  displayDeleteAccountOnPermissionsPage: true,
  deleteAccountCTA: 'DELETE ACCOUNT',
  deleteAccountDescription: 'Account deletion is permanent. Orders, loyalty benefits, and rewards will be lost, and future account creation may be restricted.',
  deleteAccountPageTitle: 'Account Deletion',
  deleteAccountPageDescription:
    'Deleting your account will result in the immediate loss of all order history, loyalty points, and rewards. Please note that you may be restricted from creating a new account in the future.',
  deleteAccountPageSubtitle: 'Enter the mobile no. of your registered account',
  deleteAccountMobilePlaceholder: 'Mobile no.',
  deleteAccountValidationErrorMobile: 'Please enter a valid 10-digit mobile number.',
  deleteAccountSendOtpError: 'Unable to send verification code. Please try again.',
  deleteAccountMobileHint:
    'Mobile no. is used for verification only.{br} This number will not be saved.',
  deleteAccountCtaButton: 'DELETE ACCOUNT',
  deleteAccountOperatedByText:
    'Official account deletion page for {brandName}.{br} Operated by December Technologies Private Limited.',
  deleteAccountVerifyNumberTitle: 'Verify Number',
  deleteAccountProceedCta: 'PROCEED',
  deleteAccountConfirmTitle: 'Delete your Account',
  deleteAccountConfirmSecondaryCta: 'DO NOT DELETE',
  deleteAccountConfirmPrimaryCta: 'DELETE',
  deleteAccountTypeDeletePlaceholder: 'Type DELETE',
  accountNotFoundTitle: 'Account not Found',
  accountNotFoundMessage:
    'We were not able to find any account with mobile no. {phone} for {appName}.',
  accountNotFoundOkCta: 'OK',
  accountAlreadyDeletedTitle: 'Account Already Deleted',
  accountAlreadyDeletedMessage:
    'The account associated with {phone} has been deleted per your request. If you have questions or need further assistance, please contact us at support@fudr.in',
  recoverAccountTextWith24Hours:
    'If you wish to recover this account, please contact us within 24 hours at support@fudr.in',
  deletionStartedDescription:
    "We've started the process of deleting your account. It may take upto 72 hours to complete the process. We'll mail you once the process is complete.",
  deleteAccountStartedImageAlt: 'Account deletion started',
  deleteAccountStartedOkCta: 'OK',
  accountAlreadyDeletedImageAlt: 'Account already deleted',
  accountAlreadyDeletedOkCta: 'OK',
  pointEarned: 'Points Earned',
  walletRechargeBonusTitle: 'Wallet Recharge Bonus',
  pointAdjusted: 'Points Adjusted',
  appPermissions: 'App Permissions',
  communication: 'Communication',
  preferredChannelText: 'Preferred channels for receiving marketing messages',
  offersText: 'Offers',
  cravingForMore: 'Craving for More',
  menuUpsellSuggestionsTitle: 'Recommended',
  menuUpsellPairWithTitle: 'People usually pair this with',
  upsellSuggestionsError: 'Unable to load suggestions. Please try again.',
  upsellSuggestionsRetry: 'Try Again',
  addMoreItems: 'ADD MORE ITEMS',
  addSpecialInstructions: 'ADD SPECIAL INSTRUCTIONS',
  specialInstructionsTitle: 'Special Instructions',
  getCouponCTA: 'GET COUPON',
  noBrandDealDescription: 'Seems like there are no offers at the moment',
  noBrandRewardDescription: 'Seems like there are no rewards at the moment',
  howThisWorks: 'How this works',
  howItWorks: 'How it Works',
  getCouponOnSubscribe: 'You’ll get a Coupon code on collecting this reward',
  showCouponBeforeOrder: 'Visit the restaurant and show the coupon code before placing your order',
  redeemCouponAtBillGeneration:
    'The restaurant will redeem your coupon at the time of bill generation',
  offerDetailsText: 'Offer Details',
  applicableForNewCustomers: 'Applicable for first time customers',
  maximumDiscountText: 'Maximum discount {formattedMaxValue}',
  alreadyHaveCoupon: 'You already have a coupon code',
  visitRestaurantToReedem: 'Visit restaurant to redeem',
  useCouponOnNextOrder: 'Use this coupon on your next order',
  instantDealText: 'Instant Deal',
  viewDetailsText: 'VIEW DETAILS',
  couponStreakText: 'Coupon Streak',
  couponApplicableOn: 'Coupon Applicable on',
  viewOnMap: 'VIEW ON MAP',
  redeemedCouponAndSavedText: 'You have redeemed this coupon and saved {symbol}{discountAmount}',
  redeemedCouponAndAvailedText: 'You have redeemed this coupon and availed Free {applicableItem}',
  locked: 'Locked',
  unlockCouponAfterText: 'Unlock this coupon code after {orderCount} Order',
  redeemed: 'Redeemed',
  expired: 'Expired',
  rewardExpiredOnText: 'Reward expired on {expiredDate}',
  willUnlockOnText: 'This coupon will unlock on {unlockDate}',
  couponCodeLocked: 'Coupon Code Locked',
  showCouponToAvail: 'Show this coupon code to avail offer',
  yourCouponCode: 'Your Coupon Code',
  goToRewardsPageCTA: 'GO TO REWARDS PAGE',
  couponAdded: 'Coupon added in Claimed Rewards',
  howToRedeem: ' How to Redeem Coupon',
  visitRestaurantShowCoupon:
    'Visit the restaurant and show the coupon code before placing your order',
  restaurantWillRedeem: 'The restaurant will redeem your coupon and provide applicable {offerType}',
  deleteYourAccount: 'Delete your Account',
  areYouSure: 'Are you sure?',
  allInformationWillBeLost: 'All information related to your account will be lost forever.',
  otpSent: 'OTP Sent',
  resendOtpCaps: 'RESEND OTP',
  points: 'POINTS',
  rewardPointsText: 'R E W A R D {br} P O I N T S',
  rewardPointsSpentDescription: '{rewardPoints} {currencyName} available',
  unlockRewardMilestoreDescription: 'Unlock reward on reaching {pointPrice} points',
  viewOldCoupons: 'VIEW OLD COUPONS',
  viewMoreText: 'VIEW MORE',
  myRewards: 'My Rewards',
  myRewardsDescription: 'Redeem your collected rewards on next order',
  noRewardsText: 'No rewards at the moment',
  redeemableRewardsText: 'All your redeemable rewards will be shown here',
  excitingOffers: 'Exciting Offers',
  excitingOffersDescription:
    "We have some exciting offers for your next visit. It's for limited time, grab your coupon before it ends.",
  pointsRedeemed: 'Points Redeemed',
  pointsUsed: 'Points Used',
  pointsEarnedForSpending: 'Amount spent {formattedNetAmount}',
  pointsEarnedForRecharging: 'Wallet recharge {formattedNetAmount}',
  claimedReward: 'Collected Reward - {sourceName}',
  noDataToShow: 'No Data to show',
  viewRewards: 'VIEW REWARDS',
  claimRewards: 'COLLECT REWARDS',
  loginCTA: 'LOGIN',
  loginRequiredTitle: 'Login Required',
  viewOffers: 'VIEW OFFERS',
  dealRedeemedPopupTitle: 'Coupon already Redeemed',
  dealRedeemedPopupDescription:
    'Hi {username},{br}  You’ve already redeemed the coupon on {redeemDate}  and got discount of {amount}. We’ve a coupon you might be interested in.',
  dealAlreadyRedeemedItemFreeDescription:
    'Hi {username},{br} You’ve already redeemed the coupon on {redeemDate} and availed free item. We’ve a coupon you might be interested in.',
  dealAlreadySubscribedDescription:
    'Hi {username},{br} You’ve already claimed this coupon on {subscribedDate}. Please check Claimed Rewards section to view coupon code',
  lastUpdatedText: 'Last updated',
  redeemOn: 'Redeemed on {redeemTime}',
  expiredOn: `Expired on {expireTime}`,
  validTill: 'Valid till {expireTime}',
  validFromTo: 'Valid from {redeemableTime} - {expireTime}',
  validFrom: 'Valid from {redeemableTime}',
  validOn: 'Valid on {time}',
  added: 'Added',
  deducted: 'Deducted',
  pointsText: 'Points',
  actionText: 'Action',
  activityDetails: 'Activity Details',
  dateAndTime: 'Date & Time',
  billNo: 'Bill no.',
  billAmount: 'Bill Amount',
  rechargeAmount: 'Recharge Amount',
  outlet: 'Outlet',
  claimedRewardText: 'Claimed {br} Reward',
  earnPointOneSpend: 'Earn point on every spend',
  earnPoints: 'Earn Points',
  unlockRewards: 'Unlock & Claim Rewards',
  unlockRewardsPromotion: 'Unlock Rewards',
  redeem: 'Redeem',
  redeemEarnedRewardsOnNextVisit:
    'Show the coupon code and Redeem your collected rewards on your next visit.',
  redeemEarnedRewardsOnNextVisitPromotion: 'Redeem your earned rewards on your next visit.',
  getBirthdayRewards: 'Get Birthday Rewards',
  getAnniversaryRewards: 'Get Anniversary Rewards',
  addBirthday: 'Add Birthday',
  addAnniversary: 'Add Anniversary',
  manyMoreOffers: 'Many more Offers',
  reasonToVisitUsAgain: 'We make sure that you always have a reason to visit us again.',
  birthdayRewardCardTitle: 'Get Exciting Reward for your Birthday Month',
  anniversaryRewardCardTitle: 'Get Exciting Reward for your Anniversary Month',
  birthdayProvidedInfo:
    'Thanks for Providing your Birthday. {br}To view your Birthday Rewards go to {br}More > Rewards Program',
  anniversaryProvidedInfo:
    'Thanks for Providing your Anniversary Date. {br}To view your Anniversary Rewards go to {br}More > Rewards Program',
  claimBirthdayRewardText: 'Birthday Reward',
  claimAnniversaryRewardText: 'Anniversary Reward',
  birthdayRewardsText: 'Birthday Rewards',
  welcomeRewardText: 'Welcome Reward',
  welcomeRewardDescription: 'Your reward is just a tap away',
  redeemRewardPointsText: 'Collect Reward with {currencyName}',
  pointsAvailable: '{rewardPoints} {currencyName} available',
  birthdayRewardsTitle: 'Choose from a variety of rewards for your birthday month',
  birthdayRewardDetails: 'Birthday Reward Details',
  claimCTAText: 'Claim it',
  birthdayRewardAvailableDate: 'Available from {startDate} - {endDate}',
  anniversaryRewardAvailableDate: 'Available from {startDate} - {endDate}',
  active: 'Active',
  noActiveRewardText: 'No Active Rewards at the moment',
  noInactiveRewardText: 'No Redeemed / Expired Rewards at the moment',
  redeemedOrExpired: 'Redeemed / Expired',
  greeterContent: 'Glad to have you back',
  notTakenRewards: `You've not taken any Rewards yet`,
  invalidOTPMessage: 'The OTP you have entered is incorrect',
  showThisCodeToRedeem: 'Redeem this coupon{br} on your next order',
  cretingSomethingExciting: 'We’re creating something exciting !!! {br} Please check back later',
  swipeToClaimReward: 'Swipe to Collect',
  joinRewardClubLink: 'Not a member yet? {joinRewardsClub}',
  joinRewardsClub: 'Join Reward Club',
  alreadyAMember: 'Already a Member? {login}',
  welcomeRewardsText: 'Welcome Rewards',
  welcomeRewardDetails: 'Welcome Reward Details',
  welcomeRewardsTitle: 'Choose from a variety of rewards',
  anniversaryRewardsText: 'Anniversary Rewards',
  anniversaryRewardDetails: 'Anniversary Reward Details',
  anniversaryRewardsTitle: 'Choose from a variety of rewards for your anniversary month',

  claimRewardCTAText: 'Collect Reward',
  greetingSubtitle: ' ',
  greetingTitle: ' ',
  joiningRewardText: 'Joining Reward',
  joiningReward:
    'We know how to welcome our guests. Get a special reward for joining Rewards Club.',
  accountAlreadyExists: 'Account exists. Please log in.',
  accountNotExists: "Account doesn't exists. Please signup",
  welcomeOnboard: 'Welcome Onboard,{br} {name}',
  welcomeGuestName: 'Welcome, {name}!',
  memberSince: 'Member since',
  viewOtherBenefits: 'View Other Benefits',
  collectPoint: 'Collect {earn} point for every {unit} {spend} spent.',
  collectPointWithCurrency: 'Collect {earn} {currencyName} for every {unit} {spend} spent.',
  collectPointInPer: 'Earn {earn}{unit} of bill value as {currencyName}',
  collectPointWithFixedAndMinSpend:
    'Earn {earn} points on every order with minimum order of {minSpend}',
  collectPointinFixed: 'Earn {earn} points on every order with no minimum order value',
  collectMaxPointInPer: 'Earn upto {earn}{unit} of bill value as {currencyName}',
  spendAndEarnPointOnSelectedItems:
    'You earn {earn} point for every Rs. {spend} spent on items labelled with “Earn Points”. Look for the below tag to identify eligible items.',
  earnPointOnSelectedItems: 'Earn {earn} {currencyName} every time you purchase {tag}',
  spendAndEarnPoint:
    'Every time you spend, you collect points. {unit} {spend} spent = {earn} point.',
  minRedeemPoints:
    'On reaching {minRedeemPrice} points, you get to choose from a variety of rewards. Collect reward of your choice.',
  minRedeemPointsPromotion:
    'On reaching {minRedeemPrice} points, you get to choose from a variety of rewards.',
  unlockRewardOn: 'Unlock rewards on reaching {minRedeemPrice} points.',
  useEarnPoints: 'Use earned points on your next order',
  useEarnPointsWithCurrency: 'Pay for your order with {currencyName}',
  userEarnPointInPer: 'Use these coins to pay upto {spend}{unit} of your bill',
  okGotIt: 'Ok, got it',
  knowMore: 'Know more',
  loyaltyStampsLabel: 'Stamps',
  dealSubscribedPopupTitle: 'Coupon already Claimed',
  rewardApplicableOn: 'Coupon Applicable On',
  nearbyOutlets: 'Nearby Outlets',
  limitedOutletCouponTnC: 'Coupon applicable on limited outlets. Please see the below list',
  singleUseCouponTnC: 'This is a Single use coupon',
  offerNotClubbedCouponTnC: 'This offer cannot be clubbed with any other offer',
  redemptionCouponTnC: 'Redemption of coupon is at restaurant discretion',
  minimumOrderValueCouponTnC:
    'Minimum order amount of {formattedMinOrderValue}. It should be exclusive of taxes and other charges.',
  newlyLaunchedOutlets: 'Newly Launched Outlets',
  limitedOutletCouponTnC2: 'Coupon applicable on limited outlets.',
  nextOfferActivateCouponTnC:
    'Next offer will be activated after {couponApplicableAfter} of previous coupon redemption.',
  maximumDiscountCouponTnC: 'Maximum discount {formattedMaxValue} per order',
  orderModeApplicabilityCouponTnC: 'Only applicable on {orderModes} orders',
  getOffer: 'Get {offer}',
  limitedTimeOffersText: 'Limited Time Offers',
  appUpdateTitle: '{brandName} app needs an update',
  appUpdateDescription: 'To use this app, you need to update this app to the latest version.',
  appUpdatePrimaryCTA: 'UPDATE',
  recentlyVisitedOutlets: 'Recently Visited',
  orderTitle: 'Order',
  yourOrder: 'Your Order',
  coupons: 'Coupons',
  promoCode: 'Promo Code',
  coins: 'Coins',
  additionalDetails: 'Additional Details',
  proceedToPayCTAText: 'Proceed To Pay',
  selectDeliveryLocation: 'Select Delivery Location',
  cartHeaderTitle: 'Your Cart',
  cartOrderFor: 'Order for {guestName}',
  cartCollectionFrom: 'Collection from: {outletName}',
  cartCollectionEta: 'Collection in ~ 5-10 mins',
  cartCollectOrderEta: 'Collect order in ~5 mins',
  cartOrderForAt: 'Order for {guestName} at',
  cartPackMyOrder: 'Pack my order',
  cartCallWhenReady: 'Call me when order is ready',
  cartCookingRequestOptional: 'Add a cooking request (optional)',
  cartCookingRequestPlaceholder: 'e.g. Less ice please',
  cartFreeItemTag: 'FREE DRINK',
  cartInclTaxesCharges: 'Incl. taxes & charges',
  cartTotalBill: 'Total Bill',
  cartYouSaved: 'YOU SAVED {amount}',
  youSavedLabel: 'You saved',
  couponsTitle: 'Coupons',
  itemTotalText: 'Item Total',
  discountText: 'Discount',
  additionalDiscount: 'Additional Discount',
  freeItemText: 'Free Item',
  taxesText: 'Taxes',
  toPayText: 'To Pay',
  amountText: '{formattedAmount}',
  discountAmountText: '- {formattedAmount}',
  offerItemText: 'Offer Item',
  offerItemsText: 'Offer Items',
  freeText: 'FREE',
  userAccessBlocked: 'User access blocked',
  gotToHomeCTA: 'GO TO HOME',
  userAccessBlockedDescription:
    'This reward cannot be collected. {br} Mobile number associated with this account has been blocked by administration.',
  mobileNumberBlocked: 'This mobile no. is blocked by administration.',
  offerCollectedMultipleTimes: 'This offer can be collected {perGuestMax} times.',
  offerAlreadyRedeemedMultipleTimes:
    'You’ve already redeemed this offer multiple times, please go to More > History to view details',
  addAmountToApplyCoupon: 'Add Rs {amount} more to apply this coupon',
  orderPlaced: 'Order Placed',
  orderConfirmed: 'Order Confirmed',
  orderPartiallyConfirmed: 'Order Partially Confirmed',
  orderReady: 'Order Ready',
  orderServed: 'Order Served',
  orderCancelled: 'Order Cancelled',
  orderFailed: 'Order Failed',
  receivedOrderConfirmShortly: 'We’ve received your order and will shortly confirm it',
  startedPreparingOrder:
    'We’ve started preparing your order. It will be ready by {preparationTime}',
  startedPreparingOrderWithoutTime: 'We’ve started preparing your order',
  someItemCancelled: 'Some items have been cancelled',
  orderServedEnjoyMeal: 'Your order has been served. Enjoy your meal!',
  orderUnavailable:
    'Sorry, your order is unavailable at this time. Deducted amount will be refunded within 7 working days.',
  transactionFailed:
    'Transaction failed: If any funds were deducted, they will be refunded within 7 working days.',
  viewCancelledItems: 'View Cancelled items',
  orderId: 'Order ID',
  orderNo: 'Order no.',
  dateTime: 'Date & Time',
  discount: 'Discount',
  total: 'Total',
  totalAmountText: 'Total Amount',
  taxesAndChargesText: 'Taxes & other charges',
  orderDetails: 'Order Details',
  paymentDetails: 'Payment Details',
  refundDetails: 'Refund Details',
  applyRewardCoupon: 'Apply Coupon / {currencyName}',
  applyCouponText: 'Apply Coupon',
  emptyMenuListPlaceholder:
    'No results match with the search criteria. Please clear the search to view the menu.',
  emptyApplicableMenuListPlaceholder: 'No items are available at the moment.',
  tableNumber: 'Table {number}',
  scanQrCode: 'Scan {br} QR code',
  outletReadMode: 'We are not accepting online orders at the moment',
  outletDeactiveMode: 'We are not accepting online orders at the moment',
  outletClosedMode: 'We are closed for the day',
  outletNotOpenMode: 'We are not yet open for the day',
  notAcceptionOrdersText: 'We are not accepting {serviceType} orders at the moment',
  accountDeletionStarted: 'Account Deletion Started',
  recoverAccountText:
    'If you wish to recover this account, please contact us immediately at {supportMail}',
  outOfRestaurantScopeErrorDescription:
    'Seems like this QR doesn’t belong to {brandId}.{br} Please scan a valid {brandId}’s QR code.',
  aboutUs: 'About Us',
  franchiseEnquiry: 'Enquiry',
  franchiseEnquiryHeadline: 'Every Celebration Feels Sweeter with {brandName}',
  franchiseEnquirySubhead: 'We would love to make your celebration sweeter',
  franchiseEnquiryFullName: 'Full Name',
  franchiseEnquiryPhone: 'Phone no.',
  franchiseEnquiryEmail: 'Email',
  franchiseEnquiryNotes: 'Additional Notes',
  franchiseEnquirySubmit: 'Submit',
  franchiseEnquirySuccessMessage:
    'Enquiry submitted successfully. We will get back to you soon.',
  franchiseEnquiryErrorMessage: 'Something went wrong. Please try again.',
  workWithUs: 'Work with us',
  orders: 'Orders',
  menu: 'Menu',
  recommended: 'Recommended',
  cameraAccessError: 'Seems like camera access is blocked',
  enterManualCode: 'Please enter the restaurant code mentioned below QR code',
  scanQRCodeText: 'Scan QR code to order',
  undetectScanCode: 'Not able to Scan',
  enterCodeCTA: 'Enter Code',
  nonFudrQRCodeText: 'Please Scan a {brandId} QR code',
  enterCodeError: 'Incorrect restaurant code. Please check the code and retry.',
  invalidCodeError: 'Please enter valid restaurant code.',
  scanCodeText: 'Scan Code',
  viewMenuCTA: 'View Menu',
  pickupTimePopupTitle: 'Pickup Time',
  pickupTimePopupDescription:
    'Tell us about your estimated arrival time. This will help us to serve you better',
  changeSlotPopupTitle: 'Select Delivery Slot',
  changeSlotPopupDescription: 'Choose when you would like your order delivered',
  changeSlotPopupCTA: 'Confirm',
  changeSlotEmptyMessage: 'No delivery slots available for this community right now.',
  changeSlotErrorMessage: 'Unable to load delivery slots. Please try again.',
  changeSlotLabel: 'CHANGE',
  addHouseNoLabel: 'Add House no.',
  addHouseNumberCTA: 'Add House Number',
  addDeliveryAddressCTA: 'Add Delivery Address',
  addAddressLinkCTA: 'Add Address',
  deliveringAtHome: 'Delivering at Home',
  changeSlotNearbyStoresPrompt: 'Want your order now? Order from a nearby store',
  changeSlotViewNearbyStores: 'View nearby stores',
  communityDeliveryLabel: 'Delivery',
  communitySlotLabel: 'Delivery {date}, {timeRange}',
  mapCommunityPopupTitle: 'Map a Community for this address',
  mapCommunityPopupSubtitle:
    'We were not able to find a gated community for this address. Please select a community',
  mapCommunitySearchPlaceholder: 'Search by community name',
  mapCommunityCta: 'Map Community',
  mapCommunityEmptyMessage: 'No communities found',
  mapCommunityErrorMessage: 'Unable to load communities. Please try again.',
  differentCommunityPopupTitle: 'Different community',
  differentCommunityPopupDescription:
    'The community in the selected address doesn’t match the current community. Please select a new address or change community.',
  differentCommunityPopupNote: 'Note: Changing community will clear your cart.',
  differentCommunityChangeCta: 'CHANGE COMMUNITY',
  differentCommunityAddAddressCta: 'SELECT NEW ADDRESS',
  cartLoyaltyOnlyOnStoreOrders:
    'Reward points and coupons can be applied only on store orders.',
  orderWithinMinutes: 'Order within {minutes} mins',
  orderWithinHoursMinutes: 'Order within {hours} hrs {minutes} mins',
  selectCityTitle: 'Select City',
  viewCartCTA: 'View Cart',
  menuCategoriesTitle: 'Explore Menu',
  lastUpdatedTime: 'Last updated {time}',
  collectReward: 'Collect Reward',
  itemDetailsTitle: 'Item Details',
  pickupOrderInstruction: 'You’ll need to pickup this order from {br} {restaurantName}',
  couponApplied: 'Coupon Applied',
  itemsInCartPopupTitle: 'Items in Cart',
  siteEmptyCartPopupTitle: 'Empty Cart',
  siteEmptyCartPopupDescription: 'Your cart is empty, Please add items to view cart',
  siteEmptyCartPopupCTA: 'OK',
  outletNotServiceableTitle: 'Outlet not serviceable',
  itemsInCartChangeOutletPopupDescription: 'You’ll lose items in your cart if you change outlet',
  itemsInCartChangeModePopupDescription: 'You’ll lose items in your cart if you change mode',
  changeOutletCTA: 'Change Outlet',
  changeLocationCTA: 'Change Location',
  changeCityCTA: 'Change City',
  changeSelectedCityCTA: 'Change\nSelected City',
  changeDeliveryLocationCTA: 'Change\nDelivery Location',
  deliveryModeTitle: 'Delivery',
  confirmLocation: 'Confirm Location',
  selectAddress: 'Select Address',
  selectNewLocation: 'Select New Location',
  changeModeCTA: 'Change Mode',
  collectRewardsDescription:
    'You can collect rewards by using your {currencyName}.{br} Go to Rewards page and collect rewards',
  updateAppTitle: 'App Update Available',
  updateAppDescription: 'A new version of app is available. Update now for best experience.',
  updateAppCTA: 'UPDATE APP',
  selectOptional: 'Optional',
  selectOne: 'Select one',
  repeatCustomizationPopupTitle: 'Repeat last customization?',
  getDirections: 'get directions',
  orderCTA: 'order',
  outletTimings: 'Timings',
  multipleCustomizationsPopupTitle: 'Multiple Customizations',
  multipleCustomizationsPopupCTA: 'Go to cart',
  multipleCustomizationsPopupDescription:
    'This item has multiple customizations added. Proceed to cart to remove item?',
  multipleCustomizationsBogoPopupDescription:
    'This item has multiple customizations added. Remove this item from the below selected items list.',
  noOrdersToShow: 'No Orders to show',
  orderingComingSoon: 'Ordering Coming Soon',
  nonExistSubdomainFallbackTitle: 'Unable to reach this page',
  nonExistSubdomainFallbackDescription:
    'It seems some error has occured. Please try after sometime',
  nonExistSubdomainFallbackCTA: 'TRY AGAIN',
  pageNotFoundTitle: 'Page not found',
  pageNotFoundDescription:
    "The page you're looking for doesn't exist or may have been moved.",
  siteNotFoundTitle: '4{image}4',
  siteNotFoundDescription:
    "Page not found",
  nonVeg: 'Non Veg',
  pureVeg: 'Pure Veg',
  customizable: 'customizable',
  orderRunning: '{count} order running',
  orderAgain: 'Order Again',
  moreDetails: 'More Details',
  selectOutletManuallyCTA: 'Select Outlet Manually',
  locationPermissionDenialTitle: 'Not able to determine your device location.',
  locationPermissionDenialDescriptionAndroid:
    "For best experience, Please allow access to device's location. Go to settings > {brandName} app > Allow access to location",
  locationPermissionDenialDescriptionIOS:
    "For best experience, Please allow access to device's location. Go to settings > {brandName} app > Allow access to location",
  locationPermissionDenialDescriptionBrowser:
    "For best experience, Please allow access to device's location.",
  addCTA: 'ADD',
  viewCTA: 'VIEW',
  earnPointsPopupTitle: 'Reward Program',
  helpFaqTitle: 'Support',
  helpSupportTitle: 'Help & Support',
  supportDescription: `For any queries or issues,{br}please mail us at`,
  helpSupportMail: 'support@fudr.in',
  pointsRefreshedToast: '{currencyName} updated successfully',
  pointsRefreshDelayInMS: 1000,
  refundTxnInitiated: 'Refund of {formattedRefundAmount} initiated on {initiateDate}',
  refundTxnProcessed: 'Refund of {formattedRefundAmount} processed on {processedDate}',
  walletRefundTxnInitiated: 'Wallet refund of {formattedRefundAmount} initiated on {initiateDate}',
  walletRefundTxnProcessed: '{formattedRefundAmount} has been refunded to your {walletName}',
  someItemCancelledPostPaidOrder: 'Some items in this order were cancelled',
  someItemCancelledPrePaidOrder:
    'Some items in this order were cancelled. Balance amount will be refunded in 3-5 business days',
  dineInMinDistanceInMeter: 1000,
  selfPickupMinDistanceInKM: 10,
  notAtOutlet: 'Not at Outlet',
  tooFarFromOutet: 'Too Far From Outlet',
  outletOutOfRangeDescription:
    "Seems like you're too far from outlet. Please make sure you're ordering at the correct outlet",
  okUnderstandCTA: 'OK, I UNDERSTAND',
  loaderTimeoutInMilliSeconds: 5000,
  repeatLast: 'Repeat Last',
  addNew: 'Add New',
  howToRedeemText: 'How To Reedem',
  collectRewardOnlineInstruction: 'Collect reward, Order from app and apply coupon on cart page',
  collectRewardOfflineInstruction:
    'Collect reward, visit the restaurant and ask restaurant to apply the coupon at the time of placing order.\nRestaurant will require your registered mobile no. to generate OTP to redeem coupon.',
  orDivider: '--OR--',
  subscribeMembershipOnlineInstruction:
    'Subscribe membership, Order from app and apply coupon on cart page',
  subscribeMembershipOfflineInstruction:
    'Subscribe membership, visit the restaurant and ask restaurant to apply the coupon at the time of placing order.\nRestaurant will require your registered mobile no. to generate OTP to redeem coupon.',
  emptyVariations: 'Current selection is not available at the moment',
  streakItemSequenceTitle: '{sequence} order',
  rewardPointEarnedTextWithCurrency: `{rewardPoints} {currencyName} {br} Earned on this order`,
  rewardPointEarnedText: `{rewardPoints} {br} Earned on this order`,
  confirmationRewardCurrencyAdded: `{currencyName} Added`,
  confirmationRewardTierStrong: `{count} {currencyName} strong {br} on your {level} {tierName} card!`,
  useRewardPoint: 'Use {currencyName}',
  rewardPointUsed:
    '{redeemablePoints} {currencyName} will be used {br} Available - {balancePoints} points',
  availablePointToUse:
    'Available - {balancePoints} points {br} {redeemablePoints} {currencyName} will be used',
  zeroPointAvailable: 'Available - {balancePoints} points',
  pointDiscountText: 'Discount ({currencyName})',
  savedOnOrder: ' You’ll save {formattedAmount} on this order',
  youWillSave: 'You’ll save {amount}',
  rewardPointsTitle: '{currencyName}',
  okGotItCTA: 'Ok, Got it',
  billAmountPaidWithPoints:
    'Redeem your earned points on your next order. {billAmount}% of the bill amount can be paid using {currencyName}',
  maxRedeemablePointsPer:
    'A maximum of {maxValue}% of the available {currencyName} can be used per order',
  maxRedeemablePoints: 'A limit of {maxValue} {currencyName} applies to each order',
  vipPassTitle: '{vipPass}',
  vipPassSubtitle: 'Choose from a variety of {vipPass}',
  vipMaxDiscount: 'Max. Discount {formattedMaxValue} per order',
  vipPassDetailsText: '{vipPass} Details',
  swipeToBuy: 'SWIPE TO BUY',
  redeemPointOnNextOrder:
    'Redeem your earned points on your next order. {percentage}% of the bill can be paid through reward points. ',
  rewardPointToMoney: '{point} {currencyName} = {formattedAmount}',
  passDetails: 'Pass Details',
  noMembershipDescription: 'Seems like you’ve not taken any pass yet',
  vipPassActiveDays: 'Valid for {activeDays} days',
  membershipValidity: 'Valid till {membershipExpirationTime}',
  renew: 'RENEW',
  membershipPuschased: 'Purchased - {activationTime}',
  membershipConclulded: 'Concluded - {expireTime}',
  renewMembershipText: '{vipPass} is expired. Renew your pass and keep enjoying the benefits again',
  membershipCouponUsed: '{totalUsed} Coupon used',
  backToHomeCTA: 'Back To Home',
  stopAndBuy: 'Stop Current Pass and Buy this Pass',
  buyThisPass: 'Buy This Pass',
  stopAndBuyVIPDescription:
    'You’ll lose remaining benefits of your currently active {vipPass} if you buy this pass',
  vipPassBuyErrorMessage:
    'If you buy this pass, remaining benefits of your currently active {vipPass} will be stopped',
  couponRedeemedOn: 'Redeemed on {expireTime}',
  couponValidity: 'Valid till {expireTime}',
  noCouponToShow: 'No coupons to show',
  membershipCouponPerGuestMax: 'Pass is valid for {perGuestMax} orders upto {activeDays} days',
  recaptchaBranding:
    'This site is protected by reCAPTCHA and the Google {privacyPolicyLink} and {tncLink} apply',
  recaptchaPrivacyPolicy: 'Privacy Policy',
  recaptchaTnC: 'Terms & Conditions',
  savedByUsingRewardPoint: 'You saved {amount} by using {point} {currencyName} on this order',
  rewardPoints: 'Reward Points',
  loyaltyPoints: 'Loyalty Points',
  redeemPoints: 'Redeem Points',
  membershipAlreadySubscribedTitle: 'Pass already active',
  membershipAlreadySubscribedDescription:
    'Seems like the pass you are trying to subscribe is already active for your account',
  membershipNotFoundTitle: 'Membership Not Found',
  membershipNotFoundDescription: 'Membership not found for the user.',
  explorePassesCTA: 'View Passes',
  tryWithAnotherNumberCTA: 'Change Number',
  stayHereCTA: 'STAY HERE',
  passName: 'Pass Name',
  purchasedOn: 'Purchased on',
  validTillText: 'Valid till',
  amount: 'Amount',
  paymentMode: 'Payment Mode',
  paymentStatus: 'Payment Status',
  transactionOn: 'Transaction On',
  referenceId: 'Reference ID',
  refundMode: 'Refund Mode',
  refundStatus: 'Refund Status',
  remark: 'Remark',
  initiatedOn: 'Initiated on',
  processedOn: 'Processed on',
  paymentFailed: 'Payment Failed',
  passPaymentFailedDescription:
    'Payment for this pass has not been received. If any amount was deducted it will be refunded within 7 business days',
  updateRewardProgramTitle: 'We’ve updated our {br} Rewards program',
  seeWhatsNewCTA: 'SEE WHATS NEW',
  rewardPointRedeemRule:
    'Pay upto {maxEarn}{unit} of your bill with {currencyName}. {earn} {currencyName} = {formattedSpend}',
  updateRewardProgramTnC:
    'Your current Rewards Points will be converted into {currencyName}. {br} {br} All collected rewards will be available for redemption',
  unlimitedOrders: 'all',
  minCartValueForPointsRedemption:
    'Minimum Order of {minOrderValue} (before tax) required {br} to apply {currencyName} on this order',
  minCartValueForPointsRedemptionRewardDetails:
    '{currencyName} can be applied on orders above {minCartValueForPointsRedemption}',
  coinsCannotBeUsed: '{currencyName} cannot be used on this order',
  deliveryLocation: 'Delivery Location',
  selectDeliveryAddress: 'Select Delivery Address',
  selectLocation: 'Select Location',
  whereAreYouOrdering: 'Where are you Ordering',
  gatedCommunityTitle: 'Gated Community',
  gatedCommunitySubtitle: 'Order in advance, receive on delivery day',
  gatedCommunitySubtitleCards: 'Order in advance,{br}receive on delivery day',
  storeLocationTitle: '{brandName} Store',
  storeLocationTitleFallback: 'Store',
  storeLocationSubtitle: 'Order at a store for takeaway orders',
  storeLocationSubtitleCards: 'Order at a store {br}for takeaway orders',
  communityOrdersNav: 'Community Orders',
  communityOrdersPageTitle: 'Community Orders',
  communityOrdersPageSubtitle: 'Fresh favourites, delivered to your community',
  communityOrdersOrderNowCta: 'ORDER NOW',
  // Optional full-bleed hero for /site/community-ordering (Figma 56479:1620).
  // Prefer this URL when set; else first <img> in the static page HTML is used.
  communityOrdersHeroImageUrl: '',
  // Site footer v2 social icons. Same shape as socialMediaLinks:
  // [{ url, logo, type }]. When empty, footer falls back to socialMediaLinks.
  siteFooterSocialMediaLinks: [],
  selectCommunityTitle: 'Select Community',
  communitySelectionTitle: 'Gated Communities',
  selectCommunitySearchPlaceholder: 'Search by community name',
  communitySearchPlaceholder: 'Search by community name',
  communitySelectionAllBlocks: 'All',
  savedAddressesTitle: 'Saved Addresses',
  communityNotMappedLabel: 'Community not mapped',
  communityMappedLabel: 'Community: {communityName}',
  addressDetailsUnavailable: 'Address details unavailable',
  dontSeeYourCommunityPrompt:
    "Don't see your community in the list? Send us a request to add it.",
  requestCommunityTitle: 'Request a Community',
  requestCommunityNameLabel: 'Community name',
  requestCommunityAddressLabel: 'Address',
  requestCommunitySubmitCta: 'Submit',
  requestCommunitySuccessDefault: "Thanks! We've received your request.",
  requestCommunityErrorMessage: 'Unable to submit your request. Please try again.',
  nearbyCommunityRadiusInKM: '1000',
  nearbyCommunitiesSize: '5',
  viewLessText: 'VIEW LESS',
  orderingAtLabel: 'Ordering at',
  aboutUsNav: 'About Us',
  orderNowNav: 'Order Now',
  accountNav: 'Account',
  // Optional site header (v2) logo override. Empty → use brand.logoUrl as usual.
  siteHeaderLogoUrl: '',

  sitePagesPresentation: {
    default: 'sidebar',
    account: 'sidebar',
    communityOrdering: 'fullPage',
    aboutUs: 'sidebar',
    staticPagesDefault: 'sidebar',
  },
  addressDetails: 'Address Details',
  deliveryLocationTitle: 'Delivery Location',
  addressLine: 'House / Flat / Floor no.',
  landmark: 'Landmark / How to reach (optional)',
  addressMaxLength: 200,
  saveAs: 'Save as',
  office: 'Office',
  other: 'Other',
  notdeliverableText: 'Sorry, we’re not delivering at this location',
  selectMoreSpecificLocationText:
    'Please select a more specific location (area or street), not just the city',
  selectDeliveryAddress: 'Select Delivery Address',
  deleteYourAddress: 'Delete Address',
  dontDelete: "DON'T DELETE",
  delete: 'DELETE',
  areYouSureAddress: 'Are you sure, you want to delete this address',
  placeHolderTitle: "Eg. John's Place",
  deliveringAt: 'Delivering at',
  deliveredAt: 'Delivered at',
  orderOutforDelivery: 'Out for Delivery',
  orderDelivered: 'Order Delivered',
  orderoutDescription: '{rider} is out for delivery and will be there soon',
  orderoutEtaDescription: '{rider} is out for delivery and will be there by {time}',
  orderoutDescriptionDefault: 'Our rider is out for delivery and will be there soon',
  orderDeliveredDescription: 'Your order has been delivered Enjoy your meal!',
  orderReadyforDispatch: 'Your order is ready and will be dispatched shortly',
  orderReadyforPickup: 'Your order is ready{br}Please collect it from the counter',
  deliverTo: 'Deliver to',
  membershipExpiredTitle: 'Your {vipPassTitle} Expired',
  getNewPassCTA: 'Get a New Pass',
  membershipExpiredDescription: 'Get a new pass and keep enjoying the discount',
  discountSavedUsingMembership:
    'You have used this pass {totalUsed} times and saved {formattedDiscount}',
  whereYouAt: 'Where you at?',
  chooseOutlet: "Choose the outlet where you're making the payment.",
  selectBrand: 'Select Brand',
  payingAtOutlet: 'Paying - {outletName}',
  totalPayable: 'Total Payable',
  willSaveAmount: 'You’re saving {amount}',
  billPaid: 'Bill Paid',
  billCanPaidWithPoints: '{billAmount}% of the bill can be paid with {currencyName}',
  everySpendEarnPoint: 'For every {unit}{spend} spent,  you earn {earn} {currencyName}',
  spotlightTitle: 'Spotlight',
  mapMarkerDeliveryText: 'Order will be delivered here',
  noSavedAddressText: 'No saved addresses found',
  redirectingToPG: 'Redirecting to {br} Payment Gateway',
  doNotCloseApp: 'Please do not close the application',
  processingPayment: 'Processing Payment',
  processingPaymentDescription:
    'We are processing your payment, {br} please do not close the application',
  currentLevelTagText: 'Current Level',
  nextLevelTagText: 'NEXT LEVEL',
  finalLevelTagText: 'FINAL LEVEL',
  tierBirthdayAnniversaryBenefit: 'Complementary anniversary and birthday offers.',
  tierAnniversaryBenefit: 'Complementary anniversary offer.',
  tierBirthdayBenefit: 'Complementary birthday offer.',
  tierEligibilityVisit:
    'Visit {minSpend} times within {duration} {durationUnit} to reach this level',
  tierEligibilitySpend:
    'Spend {minSpend} within {duration} {durationUnit} to reach this level',
  tierEligibilityOrder:
    'Order {minSpend} times within {duration} {durationUnit} to reach this level',
  tierEligibilityPoint:
    'Earn {minSpend} points within {duration} {durationUnit} to reach this level',
  tierProgramPromotionTNC:
    'Earn {currencyName} with every purchase and redeem them towards your bill payments. Each {currencyName} holds a value of {unitValue}, allowing you to save as you spend.{br}{br}Ascend through tier levels to unlock additional perks and benefits',
  viewTierLevelsCTA: 'View Tier Levels',
  additionalBenefits: 'Additional Benefits',
  tierLevelsPopupTitle: 'Tier Levels',
  myBenefitsTabLabel: 'MY BENEFITS',
  // Reward Program Details tabs: show My Benefits unless brandResource sets false.
  showMyBenefitsTabInRewardProgram: true,
  levelTabLabel: 'LEVELS',
  faqsTabLabel: 'FAQS',
  enterAmountShownOnBill: 'Enter amount shown on the bill',
  coinsCantBeClubbedWithCoupon: '{currencyName} cannot be clubbed with coupons',
  nextText: 'NEXT',
  billDetails: 'Bill Details',
  totalBillAmount: 'Total Bill Amount',
  coinUsed: 'Coin used',
  totalSaving: 'Total Saving',
  selectOutletText: 'Select Outlet',
  noOutletForSelectedCity: 'No outlet for selected city',
  amountSaveOnBill: '{amount} saved on your bill',
  amountPaid: 'Amount Paid',
  transactionId: 'Transaction ID',
  cancelPayment: 'Cancel Payment',
  exitPayEarnConfirmationMsg: 'Are you sure you do not want to pay bill and earn {currencyName}',
  doNotPayCTA: 'DO NOT PAY',
  outletSize: 100,
  earnCoinInPercentage: 'Earn {earn}{unit} of bill value as {currencyName}',
  tryAgainCTA: 'Try Again',
  tooFarFromOutetDescription:
    'Seems like you are too far from outlet. Please make sure you’re paying at the correct outlet',
  nearbyOutletDistanceInMeter: '20',
  annualSpend: 'Annual spend {amount}',
  tierTitle: '{title} Level Benefits',
  loyaltyCardTierTitle: '{title} Level',
  clickToStampCTA: 'CLICK TO STAMP',
  freeDrinkLabel: 'Free Drink',
  unlockNextLevelText: 'Unlock for next level',
  levelCompletedText: 'Level Completed',
  applyOffersOnNextPage: 'Apply coins / coupon on next page',
  swipeToPayAmount: 'SWIPE TO PAY {formattedAmount}',
  termsAndConditions: 'Terms & Conditions',
  inTheTier: 'In the {currentTier} level,',
  coinsEarned: '{amount} {currencyName} Earned',
  transactionDetails: 'Transaction Details',
  cookingRequest: 'Cooking Request ',
  readOnlyMenuServiceTitle: 'Pickup',
  paymentFailedDescription:
    'We are unable to process your payment. If any money was deducted it will be refunded in 2-3 business days',
  backToCartCTA: 'BACK TO CART',
  paymentSuccess: 'Payment Successful',
  userLocationSearchPlaceholder: 'Search by locality or street name',
  allOutlets: 'All Outlets',
  doNotRemove: 'DO NOT REMOVE',
  remove: 'Remove',
  switchRewardWarningTitle: 'Applied {type} will be removed',
  switchRewardWarningDesc: 'If you change the tab, {type} applied on your bill will be removed.',
  coinsText: 'coins',
  couponText: 'coupon',
  paymentProcessingInSeconds: '180',
  rewardProgramDetails: 'Reward program details',
  hideRewardsBenefit: false,
  useSemiBoldFont: false,
  bookTable: 'Book Table',
  tableOutlet: 'Choose the outlet where you want to book table',
  helpAndSupport: 'Support',
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  privacyPolicyAndTermsOfServiceDescription:
    'By proceeding, I agree to {brand}’s {br}{privacyPolicy} and {termsOfService}',
  privacyPolicyAndTermsOfServiceDescriptionInternal:
    'By proceeding, I agree to {brand}’s {privacyPolicy} and {termsOfService}',
  invalidGroupSizeMessage: 'Please enter valid group size',
  exitTableBooking: 'Exit Table Booking?',
  dontWantToBookTable: 'Are you sure you do not want to book a table?',
  dontBookTableCTA: 'DONT BOOK TABLE',
  bookingForLargeParty: 'Booking for Large Party?',
  giveUsCallForLargeParties:
    'Please give us a call for booking for large parties. This will help us to provide you a better experience',
  bookedSlotWillbeCancelled: 'If you cancel your booking, your booked slot will be cancelled.',
  cancelBooking: 'CANCEL BOOKING',
  dontCancel: 'DON’T CANCEL',
  guests: 'Guests',
  whenAreYouVisiting: 'When are you visiting?',
  noSlotsAvailable: 'No slots available',
  customCaps: 'CUSTOM',
  callOutlet: 'Call Outlet',
  callOutletCaps: 'CALL OUTLET',
  forLargeParties: 'For Large Parties',
  tableBooked: 'Table Booked',
  bookingCancelled: 'Booking Cancelled',
  forGroupSize: 'For {groupSize}',
  payAndEarn: 'Pay & Earn',
  bookingDetails: 'Booking Details',
  bookings: 'Bookings',
  bookingCancelledCaps: 'BOOKING CANCELLED',
  seatsLeft: '{remains} Seats Left',
  bookTableConfig: {
    default: {
      group: { size: [1, 2, 3, 4, 5, 6, 7, 8], isCustomizable: true },
      date: {
        maxDaysAhead: 30,
        bookingTimeLimitInMin: 0,
        slots: [
          { start: '08:00', end: '10:00', type: 'BREAKFAST' },
          { start: '12:00', end: '14:00', type: 'LUNCH' },
          { start: '18:00', end: '24:00', type: 'DINNER' },
        ],
      },
      tnc: [
        'Reach the restaurant 15 mins before your booked slot',
        'Booking cannot be transferred to another individual',
        'Booking will be cancelled if not reached on time',
        'Right of admission reserved',
      ],
      lookbackBookingsTimeInHours: 6,
    },
  },
  addOnMinSelection: 'Required | Select any {minSelection} option',
  addOnMinSelectionMultiple: 'Required | Select any {minSelection} options',
  addOnMinAndMaxSelection: 'Required | Select any {minSelection} to {maxSelection} options',
  addOnMaxSelection: 'Optional | Select upto {maxSelection} option',
  addOnMaxSelectionMultiple: 'Optional | Select upto {maxSelection} options',
  maxLimitWarningAddon: 'You have reached the maximum limit for this item',
  minRequiredWarningAddon: 'You need to select at least {minSelection} item from {category}',
  bookingYourTable: 'Booking your Table',
  pleaseDoNotCloseApplication: 'Please do not close the application',
  alreadyTooManyBooking: 'Already Too Many Bookings',
  have5ActiveBookings:
    'You already have 5 active bookings. A guest cannot have more than 5 active bookings. Please book from a different account.',
  sameSlotBooking: 'Booking already exists',
  sameSlotBookingDescription:
    'Booking already exists for this time slot. Please try booking a different slot.',
  updateProfileTitle: 'One Last Thing',
  updateProfileDescription: 'Please update your profile to continue',
  updateProfileCTA: 'UPDATE PROFILE',
  selectItem: 'Select',
  itemsAddedInCart: 'Items added in cart',
  customizationPopupAddItemCTA: 'ADD Item | {formattedAmount}',
  continueCTA: 'Continue',
  bogoItemPlaceholderText: '{stack} Item',
  bogoOfferPageTitle: 'Buy {buyQuantity} Get {getQuantity} Offer',
  bogoItemsTitle: 'Buy {buyQuantity} Get {getQuantity} Items',
  missedPointsOnOrder: "You could've {br} Earned Reward Points {br} on this order",
  earnedPointsOnOrder: "You've Earned Reward Points {br} on this order {br} Download app to Redeem",
  orderFromAppToEarnPoints: 'Order from app and earn points on every order',
  orderFromAppToRedeemPoints: 'Order from app to redeem your points',
  orderFromAppToRedeemPass: 'Order from app to redeem your pass',
  downLoadAppCTA: 'DOWNLOAD APP',
  downloadAppToManageProfileTitle: 'Download app to manage profile',
  downloadAppToManageProfileDescription:
    'You can manage your profile and do a lot more things on our app',
  swipeToBookTable: 'SWIPE TO BOOK TABLE',
  bogoOfferInstruction:
    'Collect reward, open menu on app, tap on ‘Offer Banner’, choose items of your choice. Coupon will be applied automatically.',
  bogoCouponTnC: 'Maximum of {getQuantity} item will be free on an order',
  bogoCouponPerTnC: 'Maximum of {getQuantity} item will be discounted on an order',
  bogoCouponMenuValidation: 'Valid on selected items',
  bogoCouponCTA: 'Select Items',
  bookingId: 'Booking ID - {bookingId}',
  offerExistInCart: 'Offer already added in cart',
  offerExistInCartDescription: 'Following items in your cart are part of the offer',
  removeItemsCTA: 'Remove Items',
  goToCartCTA: 'Go To Cart',
  applyCouponCTA: 'APPLY THIS COUPON',
  offerRemovePopupTitle: 'Applied coupon will be removed',
  offerRemovePopupDescription:
    'If you remove this item, your below applied coupon will also be removed.',
  offerRemovePopupCTA: 'REMOVE',
  offerRemovePopupSecondaryCTA: 'DO NOT REMOVE',
  offerNotApplicableTitle: '{preText} not applicable at the moment',
  offerNotApplicableDescription: 'Not applicable at the moment',
  offerNotApplicableTitle2: 'Offer not applicable at the moment',
  viewOfferDetails: 'View Offer Details',
  viewDetailsCTA: 'View Details',
  rateYourExperienceCTA: 'Rate Your Experience',
  yourRatingText: 'Your Rating',
  feedbackVisibleTimeInMinutes: '30',
  submitFeedbackCTA: 'SUBMIT FEEDBACK',
  orderFeedbackTitle: 'Order feedback',
  viewOrderText: 'view order',
  foodRatingQuestion: 'How was the food?',
  overallRatingQuestion: 'How was your experience?',
  serviceRatingQuestion: 'How was the service?',
  ambienceRatingQuestion: 'How was the ambience?',
  feedbackSuccessText:
    "Thanks a lot for showing us your love. We'll make sure that your next visit is awseome.",
  feedbackSuccessBadText:
    'Thank you for sharing your honest feedback.  We apologise for not meeting your expectations. Our team will get back to you to discuss it in detail.',
  weLoveYoutooText: 'We love you too',
  weAreImporvingText: 'We are improving',
  weAreSorryText: "We're so sorry",
  enjoyCouponText: 'Enjoy this coupon on your next visit',
  tellUsMore: 'Tell us more (optional)',
  lastOrderListSize: '1',
  lastOrderPreviousDays: '3',
  collectOrder: 'Collect your order from the counter',
  deliveryChargesTitle: 'Delivery Charges',
  deliveryDiscount: 'Delivery Discount',
  serviceChargeTitle: 'Service Charge',
  serviceChargeDescription:
    'Service charge goes directly to the hardworking team who prepared and served your meal today.',
  removeServiceChargeCTA: 'Remove Service Charge',
  removeServiceChargeTitle: 'Remove Service Charge',
  removeServiceChargeDescription:
    'Are you sure to remove service charge? This charge ensures our team is supported and rewarded for their hard work',
  serviceChargeRemovalReasonPlaceholder: 'Please provide a reason for removal',
  doNotRemoveServiceCharge: 'DO NOT REMOVE',
  removeServiceCharge: 'REMOVE',
  includeServiceCharge: 'Include',
  serviceChargeRemoved: '(removed)',
  orderHistoryPopupTitle: 'Order History',
  orderHistoryPopupSubtitle: 'Download app to view your order history',
  orderHistoryPopupDesciption:
    'You can view your order history and do a lot more things on our app.',
  orderHistoryPopupCTA: 'Download APP',
  selfPickupLabel: 'Self Pickup',
  switchText: 'SWITCH',
  addMoreItemsTitle: 'Add more items',
  goToMenuCTA: 'GO TO MENU',
  minBillAmountTnc:
    'Minimum bill of {formattedMinBillValue} is required for delivery orders {br} Please add some more items in your cart',
  // Cart footer (Figma 56348:22216) — line above pay / swipe CTA when under delivery min.
  cartMinOrderForDeliveryHint: 'A minimum order of {formattedMinOrderValue} is required for delivery',
  // paymentPollInterval: [0, 5, 10, 15, 25, 30, 5, 10, 15, 25, 30],
  paymentPollInterval: [0, 5, 10, 15, 20, 20, 20, 20, 20, 15, 5, 5],
  viewAllRatingsCTA: 'View all Ratings',
  featuredItemsTitle: 'Featured Items',
  exploreMenuTitle: 'Explore Menu',
  newlyLaunchedTitle: 'Newly Launched',
  cityTilesHeading: 'Find Your Nearest {brandName}',
  cityTilesExploreMore: 'Explore More',
  productGridSeeMore: 'SEE MORE',
  locationsPageTitleHighlight: 'Find Your Nearest {brandName}',
  swipeToPlaceOrder: 'Swipe To Place Order',
  rateYourLastExperience: 'Rate your last experience',
  swipeToPay: 'Swipe To Pay',
  nearby: 'Nearby',
  outletDistanceDisplayThresoldInKm: '1',
  nearbyOutletThresoldInMeter: '50',
  addToCartCTA: 'Add To Cart',
  availRewardWithPoints: 'Avail this reward with {pointPrice} reward points',
  rewardDetails: 'Reward Details',
  pointsDeducted: '{pointPrice} points will be deducted',
  appApplicableOnly: 'Applicable only on app orders',
  swipeToCollectReward: 'Swipe to Collect',
  excludeReservationStatus: 'PENDING',
  checkedInText: 'CHECKED IN',
  FoodImagePlaceholderUrl: 'https://assets.fudr.in/assets/images/food-image-placeholder.png',
  // Distinct from FoodImagePlaceholderUrl — used by MenuCategoryCard only.
  CategoryImagePlaceholderUrl:
    'https://assets.fudr.in/assets/images/category-image-placeholder.png',
  maximumDiscountText2: 'Upto {formattedMaxValue}',
  knowMoreCTA: 'Know More',
  selectItemCTA: 'Select Items',
  applyOfferCTA: 'Apply Offer',
  offerText: 'Offer',
  rewardText: 'Reward',
  couponAlreadyTaken: 'You already have taken coupon with your {currencyName}',
  dayValidationError: '{preText} applicable only on {applicableWeekdays}',
  serviceTypeValidationError: 'This Offer is only applicable on {orderModes} orders',
  timeValidationError: '{preText} is available only from {startTime} to {endTime}',
  dateValidationError: '{preText} is available from {activationTime}',
  dateValidationErrorAfter: '{preText} available after {activationTime}',
  rewardValidationTitle: '{preText} not applicable at the moment',
  trackOrder: 'Track order',
  offerAlreadyAppliedTitle: '{preText} already applied',
  removeOfferCTA: 'Remove {preText}',
  amountValidationError:
    'This {preText} is applicable on minimum order amount of {formattedMinOrderValue}',
  amountValidationErrorTitle: 'Add More Items',
  guestEligibilityTotalSpendMessage:
    'Spend {formattedAmount} more{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}} to unlock this {dealCategory, select, RW {reward} other {offer}}',
  guestEligibilityOnlineTotalSpendMessage:
    'Spend {formattedAmount} more on online orders{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}} to unlock this {dealCategory, select, RW {reward} other {offer}}',
  guestEligibilityTotalOrdersMessage:
    'Place {count, number} more {count, plural, one {order} other {orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}} to unlock this {dealCategory, select, RW {reward} other {offer}}',
  guestEligibilityOnlineTotalOrdersMessage:
    'Place {count, number} more online {count, plural, one {order} other {orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}} to unlock this {dealCategory, select, RW {reward} other {offer}}',
  guestEligibilityTotalSpendMessageItem:
    'Spend {formattedAmount} more{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}}',
  guestEligibilityOnlineTotalSpendMessageItem:
    'Spend {formattedAmount} more on online orders{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}}',
  guestEligibilityTotalOrdersMessageItem:
    'Place {count, number} more {count, plural, one {order} other {orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}}',
  guestEligibilityOnlineTotalOrdersMessageItem:
    'Place {count, number} more online {count, plural, one {order} other {orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} other {}}',
  guestEligibilityAllCriteriaHeader:
    'Complete all of the following to unlock this {dealCategory, select, RW {reward} other {offer}}:',
  guestEligibilityAnyCriteriaHeader:
    'Complete any one of the following to unlock this {dealCategory, select, RW {reward} other {offer}}:',
  guestEligibilityTotalSpendRule:
    'This {dealCategory, select, RW {reward} other {offer}} {operator, select, NET {is not available} other {is only available}} for guests who {tense, select, past {spent} other {have spent}} {operator, select, GT {more than} GTE {at least} LT {less than} LTE {up to} other {exactly}} {formattedThreshold}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityOnlineTotalSpendRule:
    'This {dealCategory, select, RW {reward} other {offer}} {operator, select, NET {is not available} other {is only available}} for guests who {tense, select, past {spent} other {have spent}} {operator, select, GT {more than} GTE {at least} LT {less than} LTE {up to} other {exactly}} {formattedThreshold} on online orders{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityTotalOrdersRule:
    'This {dealCategory, select, RW {reward} other {offer}} {operator, select, NET {is not available} other {is only available}} for guests who {tense, select, past {placed} other {have placed}} {operator, select, GT {more than} GTE {at least} LT {fewer than} LTE {up to} other {exactly}} {threshold, plural, one {# order} other {# orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityOnlineTotalOrdersRule:
    'This {dealCategory, select, RW {reward} other {offer}} {operator, select, NET {is not available} other {is only available}} for guests who {tense, select, past {placed} other {have placed}} {operator, select, GT {more than} GTE {at least} LT {fewer than} LTE {up to} other {exactly}} {threshold, plural, one {# online order} other {# online orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityTotalSpendRuleItem:
    'Total spend {operator, select, GT {more than} GTE {at least} LT {less than} LTE {up to} NET {not exactly} other {exactly}} {formattedThreshold}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityOnlineTotalSpendRuleItem:
    'Online spend {operator, select, GT {more than} GTE {at least} LT {less than} LTE {up to} NET {not exactly} other {exactly}} {formattedThreshold}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityTotalOrdersRuleItem:
    '{operator, select, GT {More than} GTE {At least} LT {Fewer than} LTE {Up to} NET {Not exactly} other {Exactly}} {threshold, plural, one {# order} other {# orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityOnlineTotalOrdersRuleItem:
    '{operator, select, GT {More than} GTE {At least} LT {Fewer than} LTE {Up to} NET {Not exactly} other {Exactly}} {threshold, plural, one {# online order} other {# online orders}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityFirstOrderRule:
    'This {dealCategory, select, RW {reward} other {offer}} is only available {tense, select, past {for guests who placed no orders} other {on your first order}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityFirstOnlineOrderRule:
    'This {dealCategory, select, RW {reward} other {offer}} is only available {tense, select, past {for guests who placed no online orders} other {on your first online order}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityFirstOrderRuleItem:
    '{tense, select, past {No orders} other {First order}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityFirstOnlineOrderRuleItem:
    '{tense, select, past {No online orders} other {First online order}}{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityTotalPointsRuleItem:
    '{operator, select, GT {More than} GTE {At least} LT {Fewer than} LTE {Up to} NET {Not exactly} other {Exactly}} {threshold, plural, one {# point} other {# points}} earned{period, select, DAILY { today} WEEKLY { this week} MONTHLY { this month} YEARLY { this year} PREVIOUS_DAILY { yesterday} PREVIOUS_WEEKLY { last week} PREVIOUS_MONTHLY { last month} PREVIOUS_YEARLY { last year} other {}}',
  guestEligibilityTermsAllHeader: 'Applicable only when all of these conditions are met:',
  guestEligibilityTermsAnyHeader: 'Applicable when either of these conditions is met:',
  guestEligibilityTermsSingleHeader: 'Applicable only when this condition is met:',
  guestEligibilityAllRequirementsHeader:
    'This {dealCategory, select, RW {reward} other {offer}} requires all of the following:',
  guestEligibilityAnyRequirementHeader:
    'This {dealCategory, select, RW {reward} other {offer}} requires any one of the following:',
  expireValidationDateError: 'This {preText} is expired on {expireDate}',
  expireValidationError: 'This {preText} is expired',
  expireValidationErrorTitle: 'Offer Expired',
  useRewardPointToGetDiscount: 'Use {currencyName} to get discount on you bill',
  billAmountPaidWithPoints2: 'Pay upto {billAmount}% with {currencyName}',
  howToRedeemTitle: 'How to Redeem',
  applyPointsOnCart: 'Apply {currencyName} on cart page',
  okCTA: 'OK',
  itemNotAvailableTitle: 'Item not available',
  itemNotAvailableDescription:
    'This item is not available at the moment. {br} Sorry for the inconvenience',
  dineInDesktopUnavailableTitle: 'Not Available',
  dineInDesktopUnavailableDescription: 'Dine in mode is not available on desktop.',
  addNewAddressTitle: 'Add New Address',
  updateAddressTitle: 'Update Address',
  searchForLocationPlaceholder: 'Search for location',
  couponAppliedText: '{displayTitle} offer applied on this order',
  appliedCouponCTAText: 'YAY!',
  reviewOnSocialText:
    'Please review us on social channels and let the world know about your experience',
  reviewOnGoogeText: 'REVIEW US ON GOOGLE',
  reviewOnTripadvisorText: 'REVIEW US ON TRIPADVISOR',
  homeAddressTitle: 'Home',
  workAddressTitle: 'Work',
  otherAddressTitle: 'Other',
  nearbyOutletsSize: '5',
  viewMoreOutlets: 'View More',
  menuSearchPlaceholder: 'Search in Menu',
  menuSearchTitle: 'Search Menu',
  specialInstructions: 'Add Cooking Requests',
  swipeToOrderCTAText: 'SWIPE TO PLACE ORDER',
  swipeToPayCTAText: 'SWIPE TO PAY',
  emptyNameMessage: 'Please enter your name',
  emptyGenderMessage: 'Please select gender',
  nationalityFieldLabel: 'Nationality',
  nationalityLabel: 'Select nationality',
  emptyNationalityMessage: 'Please select your nationality',
  emptyEmailMessage: 'Please enter your email',
  emptyDOBMessage: 'Please enter a date',
  emptyAnniversaryDateMessage: 'Please enter a date',
  namePlaceHolder: 'Your Name',
  emailPlaceHolder: 'Your email id',
  otpPlaceHolder: 'OTP',
  phoneNumberPlaceHolder: 'Mobile no.',
  doaPlaceHolder: 'dd-mm-yyyy',
  doaSecondaryPlaceHolder: 'Your Anniversary date',
  dobPlaceHolder: 'dd-mm-yyyy',
  dobSecondaryPlaceHolder: 'Your Birth date',
  signUpRequiredFields: ['name'],
  pointPrice: '{pointPrice} Points',
  lockedItemDealCTA: 'View Items',
  unlockedItemDealCTA: 'Select Items',
  promoCodePlaceholder: 'Enter promo code',
  applyPromoCodeCTA: 'APPLY',
  promoCodeNotFoundDescription: 'The code you have entered is incorrect or expired.',
  promoCodeNotFoundTitle: 'Promo code not found',
  promoOfferTitle: 'Promo Offer',
  tncTitle: 'Terms & Conditions',
  promoCodeTitle: 'Have a Promo Code?',
  loyaltyPassTitle: 'Loyalty Pass',
  applyCTAText: 'Apply',
  unlockYourReward: '{name}, You’re just one step away from unlocking {displayTitle}',
  unlockYourRewardDescrption: 'Register Now to claim this offer',
  verifyAndUnlockOffer: 'Unlock Offer',
  grabOfferTitle: 'You are one step away from claiming the offer. Grab it now !',
  demoOfferTnC: 'This offer is a demo, provided exclusively for visualization purposes',
  otpVerificationTitle: 'OTP Verification',
  orderConfirmationDemoTitle: 'Thank you for completing the demo!',
  orderConfirmationDemoDescription: 'We hope you found it engaging.',
  orderNowCTA: 'Order Now',
  rewardProgramSubtext: ' ',
  dealListOrderPriority: ['loyalty', 'deal', 'promo'],
  enterReferralCode: 'Got a referral Code? {cta}',
  referralCodeFieldLabel: 'Referral Code',
  referralCodePlaceHolder: 'Enter Referral Code',
  enterReferralCodeCTA: 'Enter Code',
  invalidReferralCodeTitle: 'Invalid Referral Code',
  invalidReferralCodeDescription:
    'The referral code you’ve entered is not valid. Please enter a valid code',
  referrals: 'My Referrals',
  referralsTitle: 'Referrals',
  referralTabTitle: 'My Referrals',
  referralCardTitle: 'Refer & Earn',
  referralPopupTitle: 'Refer & Earn',
  howReferralWorksTitle: 'How it works',
  referralCodeTnc: 'Share your Referral code with your friends',
  referralPointCardRule:
    'Share your Referral code with your friends and {rewardPoints} points when they place their first order',
  referralCouponCardRule:
    'Share your Referral code with your friends and get {dealName} when they place their first order',
  referralPointRule:
    'You’ll receive ‘{rewardPoints}’ points when your friend places their first order',
  referralCouponRule:
    'You’ll receive ‘{dealName}’ reward when your friend places their first order',
  gainerPointRule: 'They’ll receive ‘{rewardPoints}’ points on signing up with your referral link',
  gainerCouponRule: 'They’ll receive ‘{dealName}’ reward on signing up with your referral link',
  referralMilestonePointRule: 'Get {rewardPoints} points on {thresold} successful referrals',
  referralMilestoneCouponRule: 'Get {dealName} on {thresold} successful referrals',
  referralMilestonePointMaxThresoldRule:
    'Get {rewardPoints} points on {thresold} successful referrals upto {maxThresold} referrals',
  referralMilestoneCouponMaxThresoldRule:
    'Get {dealName} on {thresold} successful referrals upto {maxThresold} referrals',
  referralRewardKnowMoreCTA: 'Know More',
  referralCodewhatsappShareMessage:
    'Hey, I’m using {brandName} app. Use my referral code {referralCode}',
  referralCodewhatsappShareMessagNew:
    "Craving something amazing? I use {brandName} to order all my favorites. Use my referral code {referralCode} when you sign up and you'll get a special discount. Don't miss out on the best food deals! Get the app: {appLink}",
  signupDetailsTitle: 'One Last Thing',
  unlockCouponTitle: 'You’ve unlocked {br} {displayTitle} coupon',
  unlockFallbackCouponTitle:
    '{displayTitle} coupon is for new guests, we’re happy to treat you to a {fallbackDisplayTitle} coupon!',
  unlockCouponDescription: 'We’ve DMed you this coupon. {br} Redeem it on your next order',
  couponCodeText: 'Coupon Code - {couponCode}',
  noOfferApplicableTitle: 'Sorry, this offer is not applicable',
  noOfferApplicableDescription:
    'However, we’ve got you covered with exciting rewards from our loyalty program on our App!',
  goBackCTA: 'Go Back',
  changeCTA: 'Change',
  referralMilestoneProgress: '{completed}/{total} Referrals completed',
  genderFields: ['MALE', 'FEMALE', 'OTHER'],
  unlockFallbackOfferTitle:
    '{displayTitle} is only for newly joined members. However, we have got you covered with a special treat!',
  unlockOfferTitle: 'You’ve unlocked {br} {displayTitle}',
  getBrandAppCTA: 'Go to {brandName} App',
  offerAlreadyRedeemed: 'Offer Successfully Redeemed',
  unlockMoreOfferOnApp: 'Unlock more offers and earn rewards {br} Get the app now!',
  getMoreOffers: 'Get More Offers!',
  offerExpiredTitle: 'Sorry, this offer has expired.',
  getDealTitleCTA: 'Get {dealTitle}',
  rewardPointEarnedTextWithoutCurrency: `{rewardPointsText} {br} Earned on this order`,
  cartAdditionalSupportText:
    'Prices include container charges (not applicable to beverages & add-ons)',
  orderingAtTitle: 'Ordering at',
  pleaseSelectAnOutlet: 'Please select an outlet',
  searchForOutlet: 'Search for Outlet',
  sessionExpiryLoginTitle: 'Verify it’s you',
  sessionExpiryLoginDescription:
    'You’ve been logged out due to inactivity. Please log in again with your registered  mobile number',
  sessionExpiryPopoverTitle: 'Hmm, That’s Odd...',
  sessionExpiryPopoverDescription:
    'Something feels a little different. Please log in again to continue',
  sessionExpiryPopoverCTA: 'Login Again',
  tierUpgradeBenefitText: 'Climb up to higher tier levels and unlock even bigger benefits!',
  isExternalLoyaltyEnabled: false,
  applyOfferOnCart: 'Apply this offer on the cart page while placing the order',
  viewOfferDetailsCTA: 'View Details',
  runningOrderFetchStatuses: ['UNATTENDED', 'CONFIRMED'],
  enableCategoryDropdownFeature: false,
  // When true: legacy veg/non-veg dropdown + inline header search; hide filter tags + floating footer search.
  // When false: filter tags + floating SearchBar at bottom (search-only for category layout, else search + Menu button).
  enableTypeDropdownSearchFilter: true,
  minOrderValueOfferTnc: 'Offer available on min. order of {formattedMinOrderValue}',
  refundSupportInfo: '',
  displayMenuItemImages: true, // Will keep this true always as we want to show the menu item images by default
  restrictMenuInteraction: true, // Block long-press save-image and text selection across ordering flow
  // Authentication access control (web only; native always requires auth)
  webOrderAuthAccessConfig: {
    mode: 'protected-only', // 'required' | 'protected-only'
  },
  referralRewardTitle: 'Referral Reward',
  loginToViewPoints: 'Login to view your{br}earned  points',
  emptyReferralCodeMessage: 'Please enter a valid referral code',
  emptyReferralRewardMessage:
    'No referrals yet. Share your referral code to start earning rewards!',
  referredBytext: 'Referred By',
  referredTotext: 'Referred To',
  referralActivationOnGainerActivation: 'when they sign up with your referral',
  referralActivationPostGainerPurchase: 'on their first order',
  referralActivationTotalSpend: 'on their first order of {formattedAmount}',
  referralActivationTotalSpendDefault: 'when they place their first order',
  referralRewardReceived: 'Referral reward received - {rewardValue}',
  referralRewardReceivedPoints: 'Referral reward received - {rewardTitle} {currencyName}',
  referralRewardReceivedOffer: 'Referral reward received - {rewardTitle}',
  referralRewardReceivedDefault: 'Referral reward received - {rewardTitle}',
  referralRewardPending: "You'll receive {rewardValue} {conditionText}",
  referralRewardPendingOnActivation: "You'll receive reward once they sign up on the app",
  referralRewardPendingPostPurchase: "You'll receive reward on their first order",
  referralRewardPendingTotalSpend: "You'll receive a reward on their first order of {formattedAmount}",
  referralRewardPendingTotalSpendDefault:
    "You'll receive a reward when they place their first order",
  referralRewardPendingPurchaseN: "You'll receive reward once they spend {formattedAmount} at {brandName}",
  accessDeniedPopoverTitle: 'Access Denied',
  accessDeniedPopoverDescription:
    'You’re logged in with {guestMobileNo} mobile no. This account do not have access to this page.',
  accessDeniedPopoverCTA: 'Go To Home',
  accessDeniedPopoverSecondaryCTA: 'Log Out',
  aRewardText: 'a reward',
  displayMenuItemImages: true, // Will keep this true always as we want to show the menu item images by default,
  loginToViewEarnedPointsAndReward: 'Login to view your earned points and reward',
  loginToPlaceOrder: 'Login to place order',
  selectDeliverySlot: 'Select Delivery Slot',
  confirmSlot: 'Confirm Slot',
  proceedToPaymentCTA: 'Proceed to payment',
  deliverySlotLabel: 'Delivery Slot',
  // Site cart delivery-slot row: hidden by default; set false in brandResource to show.
  hideDeliverySlot: true,
  deliveryLocationLabel: 'Delivery Location',
  menuPageLoginBannerTitle: 'There might be some exciting Offers',
  guestModeLoginRequired: 'You need to login to proceed',
  loginButton: 'Login',
  noActiveOffersTitle: 'No Active Offers',
  noActiveOffersDescription:
    'There are no active offers at the moment. As soon as a new deal drops, it will appear here',
  minBalancePointsValueForRedemption:
    'A minimum of {minBalancePointsRequired} points required to apply on this {br} order',
  displayLoyaltyPointsOnCategoryPage: false,
  serviceTypeValidationErrorTitle: 'Offer not applicable',
  smsCommunications: 'SMS',
  emailCommunications: 'Email',
  pushNotificationsCommunications: 'Push Notifications',
  whatsappCommunications: 'Whatsapp',
  rcsCommunications: 'RCS',
  permissionsAndPrivacy: 'Permissions & Privacy',
  personalInformation: 'Personal Information',
  personalInformationDescription:
    'I agree to the processing of my personal data for the purpose of order fulfillment, loyalty management.',
  serviceUpdates: 'Service Updates',
  serviceUpdatesDescription: 'I agree to receive service-related and transactional updates via SMS, WhatsApp, Email, Push notifications and RCS.',
  marketingCommunication: 'Marketing Communication',
  tncAgreedOn: '{brand}’s {privacyPolicy} and {termsOfService}',
  marketingCommunicationDescription: 'I agree to receive promotional and personalized offers, loyalty benefits, and new launch updates via SMS, WhatsApp, Email, Push notifications, and RCS.',
  mandatoryAllConsentSignupDescription: 'Please provide your consent to proceed',
  generalConsentDescription: 'I agree to the processing of my personal data for the purpose of order fulfillment, loyalty management. I may also receive service-related and promotional communications via SMS, WhatsApp, Email, Push notifications and RCS.',
  mandatoryPiConsentSignupDescription:
    'Please provide your consent to proceed',
  mandatoryTxnCommunicationConsentSignupDescription:
    'Please provide your consent to proceed',
  mandatoryMktCommunicationConsentSignupDescription:
    'Please provide your consent to proceed',
  mandatoryPiConsentErrorTitle: 'Can’t Turn Off Personal Information',
  mandatoryPiConsentErrorDescription:
    'This consent is required to process your personal data for the account management, order fulfillment and loyalty program management. Without it, we won’t be able to create your account or complete orders. You may delete your account at any time if you no longer wish to share your details.',
  mandatoryTxnCommunicationConsentErrorTitle: "Can't Turn Off Service Updates",
  mandatoryTxnCommunicationConsentErrorDescription:
    'Service-related updates are required to keep you informed about your orders, account activity, and important service notifications. Disabling this may prevent us from delivering services correctly or notifying you about critical updates. You may delete your account at any time if you no longer wish to share your details.',
  mandatoryMktCommunicationConsentErrorTitle: "Can't Turn Off Marketing Communication",
  mandatoryMktCommunicationConsentErrorDescription:
    'Marketing communication consent is required to provide you with personalized offers, loyalty benefits, and new launch updates. Disabling this may prevent you from receiving important promotional information. You may delete your account at any time if you no longer wish to share your details.',

  confirmMktCommunicationPopupTitle: 'Turn Off Marketing Communication',
  confirmMktCommunicationPopupDescription:
    'By turning this off, you may miss personalized offers, loyalty rewards, exclusive benefits, and updates about new launches.',
  confirmMktSmsCommunicationPopupTitle: 'Turn Off SMS Communication',
  confirmMktSmsCommunicationPopupDescription:
    'By turning this off, you may miss personalized offers, loyalty rewards, exclusive benefits, and updates about new launches on SMS',
  confirmMktEmailCommunicationPopupTitle: 'Turn Off Email Communication',
  confirmMktEmailCommunicationPopupDescription:
    'By turning this off, you may miss personalized offers, loyalty rewards, exclusive benefits, and updates about new launches on Email',
  confirmMktPushCommunicationPopupTitle: 'Turn Off Push Communication',
  confirmMktPushCommunicationPopupDescription:
    'By turning this off, you may miss personalized offers, loyalty rewards, exclusive benefits, and updates about new launches on Push Notifications',
  confirmMktWhatsappCommunicationPopupTitle: 'Turn Off WhatsApp Messages',
  confirmMktWhatsappCommunicationPopupDescription:
    'By turning this off, you may miss personalized offers, loyalty rewards, exclusive benefits, and updates about new launches on Whatsapp',
  confirmMktRcsCommunicationPopupTitle: 'Turn Off RCS Communication',
  confirmMktRcsCommunicationPopupDescription:
    'By turning this off, you may miss personalized offers, loyalty rewards, exclusive benefits, and updates about new launches on RCS',
  confirmMktCommunicationPopupCTA: 'Turn Off',
  confirmMktCommunicationPopupSecondaryCTA: 'Keep Receiving',
  somethingWentWrong: 'Something went wrong',
  instantCouponMessage: 'Get {title} on every bill',
  isMenuRightAligned: false,
  walletRechargePageTitle: 'Add Money',
  walletTransactions: 'Transaction History',
  addMoney: 'ADD MONEY',
  walletKnowMoreCTA: 'Know more',
  walletKnowMoreCartCTA: 'Know more',
  walletCartLabel: 'Pay from wallet and get additional benefits',
  walletPopupTitle: 'Wallet',
  walletPopupDescription: 'Add Money in wallet and get additional benefits',

  // Wallet benefit short texts (Wallet card)
  // Wallet Bonus
  walletBenefitShortTextWalletBonusPer: 'Get {value}% of the recharge amount as cashback. t&c applied',
  walletBenefitShortTextWalletBonusPerTier:
    'Get {value}% of the recharge amount as cashback on all recharges of {formattedMinAmount} and above. t&c applied',
  walletBenefitShortTextWalletBonusAbs: 'Get {value} as cashback. t&c applied',
  walletBenefitShortTextWalletBonusAbsTier:
    'Get {value} as cashback on all recharges of {formattedMinAmount} and above. t&c applied',
  // Loyalty Bonus
  walletBenefitShortTextLoyaltyBonusPer: 'Get {value}% of the recharge amount as loyalty points. t&c applied',
  walletBenefitShortTextLoyaltyBonusPerTier:
    'Get {value}% of the recharge amount as loyalty points on all recharges of {formattedMinAmount} and above. t&c applied',
  walletBenefitShortTextLoyaltyBonusAbs: 'Get {value} loyalty points. t&c applied',
  walletBenefitShortTextLoyaltyBonusAbsTier:
    'Get {value} loyalty points on all recharges of {formattedMinAmount} and above. t&c applied',
  // Coupon
  walletBenefitShortTextCouponWithTitle: 'Get {dealTitle} on all recharges. t&c applied',
  walletBenefitShortTextCouponWithTitleTier: 'Get {dealTitle} on all recharges of {formattedMinAmount} and above. t&c applied',
  walletBenefitShortTextMultipleCouponWithTitle: 'Get {count} coupons of {dealTitle} on all recharges. t&c applied',
  walletBenefitShortTextMultipleCouponWithTitleTier: 'Get {count} coupons of {dealTitle} on all recharges of {formattedMinAmount} and above. t&c applied',
  walletBenefitShortTextCouponGeneric: 'Get coupon on all recharges. t&c applied',
  walletBenefitShortTextCouponGenericTier: 'Get coupon on all recharges of {formattedMinAmount} and above. t&c applied',
  walletRechargeBenefitWalletBonusPerShort: '{value}% extra',
  walletRechargeBenefitWalletBonusAbsShort: '{formattedValue} extra',
  walletRechargeBenefitLoyaltyBonusPerShort: '{value}% Points',
  walletRechargeBenefitLoyaltyBonusAbsShort: '{value} Points',
  walletRechargeBenefitCouponSingleShort: 'Coupon',
  walletRechargeBenefitCouponMultipleShort: '{count} Coupons',
  walletRechargeBenefitsPrefix: 'Get {benefits}',
  walletRechargeEnteredAmountBenefitsLine: "You'll receive {details}",
  walletRechargeEnteredBenefitsJoiner: ' and ',
  walletRechargeEnteredBenefitWalletCashbackAbs: '{amount} as cashback',
  walletRechargeEnteredBenefitWalletCashbackPer: '{value}% as cashback',
  walletRechargeEnteredBenefitLoyaltyAbs: '{value} loyalty points',
  walletRechargeEnteredBenefitLoyaltyPer: '{value}% loyalty bonus',
  walletRechargeEnteredBenefitCouponOne: 'a coupon',
  walletRechargeEnteredBenefitCoupons: '{count} coupons',
  walletRechargeEnterAmount: 'Enter Amount',
  walletRechargeMinAmountToPlaceOrder: 'Recharge min. amount of {formattedAmount} to place order',
  cancelRechargePopupTitle: 'Cancel Recharge',
  cancelRechargePopupDescription: 'Are you sure you want to cancel wallet recharge',
  acceptText: 'ACCEPT',
  cancelText: 'CANCEL',
  stayHereText: 'STAY HERE',
  insufficientRechargePopupTitle: 'Insufficient Recharge',
  insufficientRechargePopupDescription:
    'Your order amount is more than the wallet recharge amount {br}Please do a recharge of minimum {formattedAmount} to place order.',
  goBackCTAText: 'GO BACK',
  doItAnywayCTA: 'DO IT ANYWAY',
  placeOrderCTAText: 'PLACE ORDER',
  goToCartCTAText: 'Go to Cart',
  cancelOrderAndGoToCartPopupTitle: 'Cancel Order & Go to Cart',
  cancelOrderAndGoToCartPopupDescription: 'Are you sure you want to cancel your order?',
  notSureAboutYourOrderText: 'Not sure about your order?',

  // Wallet benefit long texts (Wallet Detail)
  walletBenefitRechargeRangeBand: '{formattedMinAmount} – {formattedMaxAmount}',
  walletBenefitRechargeRangeMinOnly: '{formattedMinAmount} & above',
  walletBenefitRechargeAmountRangeMinMax:
    'Recharge Amount {formattedMinAmount} - {formattedMaxAmount}',
  /** Amount line only (label is separate in wallet benefits slab UI). */
  walletBenefitSlabRangeMinMax: '{formattedMinAmount} - {formattedMaxAmount}',
  walletBenefitRechargeAmountAbove: 'Above {formattedMinAmount}',
  // Wallet Bonus
  walletBenefitLongTextWalletBonusPer: 'Get {value}% of the recharge amount as cashback',
  walletBenefitLongTextWalletBonusPerTierMinAmount:
    'Get {value}% of the recharge amount as cashback on all recharges of {formattedMinAmount} and above',
  walletBenefitLongTextWalletBonusPerTierMinMaxAmount:
    'Get {value}% of the recharge amount as cashback on all recharges between {formattedMinAmount} - {formattedMaxAmount}',
  walletBenefitLongTextWalletBonusAbs: 'Get {value} as cashback on all recharges',
  walletBenefitLongTextWalletBonusAbsTierMinAmount:
    'Get {value} as cashback on all recharges of {formattedMinAmount} and above',
  walletBenefitLongTextWalletBonusAbsTierMinMaxAmount:
    'Get {value} as cashback on all recharges between {formattedMinAmount} - {formattedMaxAmount}',
  // Loyalty Bonus
  walletBenefitLongTextLoyaltyBonusPer: 'Get {value}% of the recharge amount as loyalty points',
  walletBenefitLongTextLoyaltyBonusPerTierMinAmount:
    'Get {value}% of the recharge amount as loyalty points on all recharges of {formattedMinAmount} and above',
  walletBenefitLongTextLoyaltyBonusPerTierMinMaxAmount:
    'Get {value}% of the recharge amount as loyalty points on all recharges between {formattedMinAmount} - {formattedMaxAmount}',
  walletBenefitLongTextLoyaltyBonusAbs: 'Get {value} loyalty points on all recharges',
  walletBenefitLongTextLoyaltyBonusAbsTierMinAmount:
    'Get {value} loyalty points on all recharges of {formattedMinAmount} and above',
  walletBenefitLongTextLoyaltyBonusAbsTierMinMaxAmount:
    'Get {value} loyalty points on all recharges between {formattedMinAmount} - {formattedMaxAmount}',
  // Coupon
  walletBenefitLongTextCoupon: 'Get {dealTitle} on all recharges',
  walletBenefitLongTextCouponTierMinAmount:
    'Get {dealTitle} on all recharges of {formattedMinAmount} and above',
  walletBenefitLongTextCouponTierMinMaxAmount:
    'Get {dealTitle} on all recharges between {formattedMinAmount} - {formattedMaxAmount}',
  walletBenefitLongTextMultipleCoupon: 'Get {count} coupons of {dealTitle} on all recharges',
  walletBenefitLongTextMultipleCouponTierMinAmount:
    'Get {count} coupons of {dealTitle} on all recharges of {formattedMinAmount} and above',
  walletBenefitLongTextMultipleCouponTierMinMaxAmount:
    'Get {count} coupons of {dealTitle} on all recharges between {formattedMinAmount} - {formattedMaxAmount}',
  walletBenefitLongTextMaxCashbackWalletBonus: 'Maximum cashback upto {formattedMaxBenefit}',
  walletBenefitLongTextMaxCashbackLoyaltyBonus: 'Maximum cashback upto {maxBenefit} loyalty points',
  walletBenefitLongTextLimitedTime: 'This is applicable for all recharges between {startDate} and {endDate}',

  walletRechargeProceedToPay: 'Swipe To Add Money',
  walletRechargeTncText: 'Wallet amount cannot be transferred to a bank account as per RBI guidelines{br}{br} Wallet amount can be used exclusively on {brandName} App {cta}',
  readTnCsCTA: 'Read TnCs',
  transactionFailed: 'Failed',
  backToWalletRechargeCTA: 'Back to Add Money',
  walletDetailsTitle: 'Wallet Details',
  walletDetailsSubtitle: 'Experience the ultimate way to order',
  walletDetailsDescription: 'Skip the checkout hassle. Securely add funds to your Wallet for seamless one-tap payments and unlock special bonuses with every top-up.',
  walletHowItWorksTitle: 'How it works',
  walletHowItWorksDescription: "Add money securely using your preferred payment method.{br}{br}Get instant bonuses or loyalty points added to your balance.{br}{br}Select 'Wallet' on cart page for a lightning-fast payment.{br}{br}Keep an eye on your spending and rewards in real-time.",
  walletRechargeSuccess: 'Added in Wallet',
  walletRechargePaymentSuccessHeadline: 'Added to Wallet',
  walletRechargeFailed: 'Wallet Recharge Failed',
  benefitsCreditedWithin24hrs: 'All the benefits will credited to your account within 24hrs',
  walletRechargeEarnedOnRecharge: 'Earned on this recharge',
  walletRechargeEarnedCashbackAbs: '{amount} Cashback',
  walletRechargeEarnedCashbackPer: '{value}% Cashback',
  walletRechargeEarnedLoyaltyAbs: '{value} loyalty points',
  walletRechargeEarnedLoyaltyPer: '{value}% loyalty bonus',
  // ICU: use '' for a literal apostrophe; '{dealTitle}' would treat {dealTitle} as literal text
  walletRechargeEarnedCouponSingle: "Get ''{dealTitle}'' coupon",
  walletRechargeEarnedCouponMultiple: "Get {count} coupons including ''{dealTitle}''",
  walletRechargeEarnedViewDetails: 'view details',
  walletRechargeEarnedBenefitsFooter: 'All benefits will be credited to your account within 24 hours.',
  walletRechargeFailedDescription: 'Sorry, we couldn\'t process your wallet recharge. Any deducted amount will be refunded within 7 working days',
  walletInsufficientBalance: 'Insufficient balance',
  walletAvailableBalance: 'Available balance - {formattedBalance}',
  walletUsableBalance: 'Usable balance - {formattedBalance}',
  walletAddMoneyCTA: 'Add Money',
  walletAddMoneyAndPlaceOrderCTA: 'ADD MONEY {br}& PLACE ORDER',
  walletPayLabel: 'Pay from Wallet',
  walletPayPartialLabel: 'Use Wallet Amount',
  walletPaymentAmountLabel: 'Amount',
  walletPaymentModeLabel: 'Payment Mode',
  walletPaymentStatusLabel: 'Payment Status',
  walletPaymentReferenceIdLabel: 'Reference ID',
  walletPaymentTransactionOnLabel: 'Transaction on',
  walletPaymentGrossAmountLabel: 'Gross Amount',
  walletPaymentTaxAmountLabel: 'Tax Amount',
  walletPaymentNetAmountLabel: 'Net Amount',
  onlineLabel: 'Online',
  offlineLabel: 'Offline',
  walletManualAddSuccess: 'Added in Wallet',
  walletBenefitSuccess: 'Added in Wallet',
  walletRefundSuccess: 'Added in Wallet',
  walletTransactionSuccess: 'Added in Wallet',
  walletManualDeductSuccess: 'Spent from Wallet',
  walletExpiredSuccess: 'Expired',
  walletDebitTransactionSuccess: 'Spent from Wallet',

  // Wallet Transaction List - Transaction Type Labels
  walletRechargeTitle: 'Wallet Recharge',
  walletBenefitTitle: 'Reward',
  walletCashbackTitle: 'Cashback',
  walletLoyaltyPointsTitle: 'Reward',
  walletCouponTitle: 'Reward',
  walletManualAddTitle: 'Wallet Recharge (offline)',
  walletRefundTitle: 'Refund',
  walletTransactionTitle: 'Wallet Recharge',
  walletManualDeductTitle: 'Offline payment',
  walletExpiredTitle: 'Expired',
  walletSpendOrderTitle: 'Amount used',
  walletSpendPassTitle: 'Amount used',
  walletDebitTransactionTitle: 'Amount used',
  walletSpendOrderSubTitle: 'Paid for the order: {sourceName}',
  walletPaymentLinkedRechargeIdLabel: 'Recharge Id',
  walletPaymentLinkedTransactionIdLabel: 'Linked Transaction',
  walletPaymentTransactionTypeLabel: 'Transaction Type',
  walletBenefitDefaultImage: 'https://assets.fudr.in/assets/images/wallet/walletBenefit.svg',
  walletBenefitsBannerImage: '',

  walletHomeBenefitsIntroText: 'Experience the fastest way to pay\nRecharge your wallet and exciting benefits',
  walletHomeBenefitsTitle: 'The more you recharge, the more you get',

  // Wallet Lifetime Savings Card - Labels
  lifetimeWalletSavingsTitle: 'Wallet Benefits',
  walletSavingsCashbackLabel: 'Cashback',
  walletSavingsLoyaltyPointsLabel: 'Points',
  walletSavingsCouponsLabel: 'Coupons',
  walletSavingsCashbackText: 'You’ve earned {formattedValue} cashback so far',
  walletSavingsLoyaltyPointsText: 'You’ve earned {value} {currencyName} so far',
  walletSavingsCouponsText: 'You’ve earned {value} coupons so far',
  walletLifetimeSavingsSubtext: 'You’ve got the following benefits so far',

  // Wallet Filter Popup - Transaction Type Labels
  walletFilterCredit: 'Credit',
  walletFilterDebit: 'Debit',
  walletFilterAll: 'All',

  // Brand App menu — food type filter chips (Figma; Open Sans Bold 10 uppercase)
  menuFoodTypeFilterTagVeg: 'VEG',
  menuFoodTypeFilterTagNonVeg: 'NON VEG',
  menuFoodTypeFilterTagClearAria: 'Clear filter',
  menuFoodTypeFilterDropdownAll: 'ALL',
  menuFoodTypeFilterDropdownVegOnly: 'Veg only',
  menuFoodTypeFilterDropdownNonVegOnly: 'Non veg only',

  // Wallet Filter Popup - Transaction Type Labels
  walletRechargeFilterTitle: 'Recharge',
  walletBenefitFilterTitle: 'Benefit',
  walletSpendOrderFilterTitle: 'Spend Order',
  walletSpendPassFilterTitle: 'Spend Pass',
  walletManualAddFilterTitle: 'Manual Add',
  walletManualDeductFilterTitle: 'Manual Deduct',
  walletExpiredFilterTitle: 'Expired',
  walletRefundFilterTitle: 'Refund',
  walletAllFilterTitle: 'All',

  // Wallet Filter Popup - Transaction Type Sub Labels
  walletRechargeFilterSubTitle: 'Amount added in wallet',
  walletBenefitFilterSubTitle: 'Benefit received on wallet recharge',
  walletSpendOrderFilterSubTitle: 'Wallet amount spent on order',
  walletSpendPassFilterSubTitle: 'Wallet amount spent on purchasing pass',
  walletManualAddFilterSubTitle: 'Amount manually added in wallet by restaurant',
  walletManualDeductFilterSubTitle: 'Amount manually deducted from wallet by restaurant',
  walletExpiredFilterSubTitle: 'Expired cashback received as benefit ',
  walletRefundFilterSubTitle: 'Amount refunded to wallet for failed payments',
  autoPlaceOrderTimerDurationPostRecharge: '3',
  taxes: '+ taxes',
  refundPolicy: 'Refund Policy',
  shippingPolicy: 'Shipping Policy',
  siteFooterTagline: "Life is a Celebration. Happiness is {brandName}.",
  siteFooterBookCelebration: 'Book your celebration',
  siteFooterCopyright: 'Copyright {brandName} {year}. All Rights Reserved. {poweredBy}',
  siteFooterCopyrightShort: '© {year} {brandName}. {poweredBy}',
  siteFooterPoweredBy: 'Powered by {brand}',
};
export default resourcesConfig;